module.exports = __webpack_public_path__ + "static/media/backgroundFootball.39775ae6.svg";